/**
 * Retrieves hedging data with derivatives Valuation
 * @param {string} fieldName: field name to update
 * @param {boolean} fieldShowLoadingName: Defines if the field must be shown loading
 */

export function getCurrencyCounterparties(
  _this,
  fieldName,
  fieldShowLoadingName
) {
  // _this[fieldShowLoadingName] = true;

  _this[fieldName] = [
    {
      id: 0,
      name: "BANCOLOMBIA",
      include: true,
      state: 0,
      quote: [],
      value: null,
      rank: null
    },
    {
      id: 1,
      name: "BOGOTA",
      include: true,
      state: 0,
      quote: [],
      value: null,
      rank: null
    },
    {
      id: 2,
      name: "BTG",
      include: true,
      state: 0,
      quote: [],
      value: null,
      rank: null
    },
    {
      id: 3,
      name: "DAVIVIENDA",
      include: true,
      state: 0,
      quote: [],
      value: null,
      rank: null
    },
    {
      id: 4,
      name: "ITAU",
      include: true,
      state: 0,
      quote: [],
      value: null,
      rank: null
    },
    {
      id: 5,
      name: "SCOTIABANK",
      include: true,
      state: 0,
      quote: [],
      value: null,
      rank: null
    }
  ];
  _this[fieldShowLoadingName] = false;

  // _this.$apollo
  //   .query({
  //     query: gql`
  //       query(
  //         $format: String
  //         $currency: Int
  //         $portfolios: portfoliosList
  //         $date: String
  //         $refresh: String
  //       ) {
  //         currency_future_hedge(
  //           format: $format
  //           currency: $currency
  //           portfolios: $portfolios
  //           date: $date
  //           refresh: $refresh
  //         ) {
  //           asian_fixing_start_date
  //           barrier
  //           barrier_2
  //           buy_sell
  //           c0
  //           c1
  //           c2
  //           counterparty
  //           currency
  //           d0
  //           days_to_expiration
  //           derivative
  //           derivative_purpose
  //           derivative_type
  //           dt_asian
  //           dtn_asian
  //           fixing_date
  //           foreign_currency
  //           fwd
  //           hedge_value
  //           hedged_date
  //           index
  //           known_ave
  //           m_asian
  //           mark_2_market
  //           n_asian
  //           notional
  //           option_type
  //           portfolio
  //           position
  //           premium
  //           premium_left
  //           premium_value_date
  //           r
  //           rf
  //           sale_date
  //           spot
  //           spot_reference
  //           strategy_code
  //           strategy_name
  //           strategy_value
  //           strike
  //           time
  //           trade_date
  //           undelying_position
  //           updated_at
  //           value_date
  //           volatility
  //         }
  //       }
  //     `,
  //     variables: {
  //       format: "json",
  //       currency: _this.currencyNumber,
  //       portfolios: { id_portfolios: _this.portfolioNumbers },
  //       date: formatDate_YMD(new Date()),
  //       refresh: Date().toLocaleString()
  //     }
  //   })
  //   .then(data => {
  //     data = JSON.parse(JSON.stringify(data["data"]["currency_future_hedge"]));
  //
  //     _this[fieldName] = data;
  //     _this[fieldShowLoadingName] = false;
  //   })
  //   .catch(function(error) {
  //     _this[fieldShowLoadingName] = false;
  //     console.log(error);
  //   });
}
